export const setActiveDeactiveProfile = ({ commit}, {payload,context}) => {
    return window.axios.post( process.env.VUE_APP_SMART_RECRUIT_API_URL + "api/js-profile-resume-active-deactive", payload ).then((response) => {
        return response.data;
    }).catch((error) => {
        context.btnName = context.lable;
        return false;
    });
};